module.exports = __webpack_public_path__ + "static/media/how-youre-feeling.a5cfe88f.svg";